import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CREATE_INVOICE_CUTOMER = "CREATE_INVOICE_CUTOMER";
export const CREATE_INVOICE_CUTOMER_LOADING =
"CREATE_INVOICE_CUTOMER_LOADING";
export const CREATE_INVOICE_CUTOMER_LOADING_FAILED =
"CREATE_INVOICE_CUTOMER_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const createInvoiceCustomerLoading = ms => ({
    type: CREATE_INVOICE_CUTOMER_LOADING,
    payload: ms
    });
    
    export const createInvoiceCustomerLoadingFailed = ms => ({
    type: CREATE_INVOICE_CUTOMER_LOADING_FAILED,
    payload: ms
    });

export function createInvoiceCustomer(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/createInvoice`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(createInvoiceCustomerLoading());
  
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response createInvoiceCustomer")
    dispatch({
    type: CREATE_INVOICE_CUTOMER,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        createInvoiceCustomerLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(createInvoiceCustomerLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(createInvoiceCustomerLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(createInvoiceCustomerLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


